import { createSlice } from '@reduxjs/toolkit';
export var factorSelectionState = {
  error: null,
  mfaByAppButtonDisabled: false,
  mfaByAppButtonLoader: false
};
export var factorSelectionSlice = createSlice({
  name: 'factorSelection',
  initialState: factorSelectionState,
  reducers: {
    /* istanbul ignore next */setError: function setError(state, action) {
      state.error = action.payload;
    },
    setMfaByAppButtonDisabled: function setMfaByAppButtonDisabled(state, action) {
      state.mfaByAppButtonDisabled = action.payload;
    },
    setMfaByAppButtonLoader: function setMfaByAppButtonLoader(state, action) {
      state.mfaByAppButtonLoader = action.payload;
      state.mfaByAppButtonDisabled = action.payload;
    }
  }
});
var _factorSelectionSlice = factorSelectionSlice.actions,
  setError = _factorSelectionSlice.setError,
  setMfaByAppButtonDisabled = _factorSelectionSlice.setMfaByAppButtonDisabled,
  setMfaByAppButtonLoader = _factorSelectionSlice.setMfaByAppButtonLoader;
export { setError, setMfaByAppButtonDisabled, setMfaByAppButtonLoader };